<template>
<div class="solution-wrapper">
  <div style="background: #E9F3FF;  padding-top: 60px;padding-bottom: 40px">
    <section class="solution en">
      <h2>Why Choose hewvo ?</h2>
      <div class="common-card">
        <div class="img-contain">
          <img class="img3 strong-img" src="@/assets/imag_4.jpg" >
        </div>
        <div class="p2" style="margin-bottom: 0;line-height: 44px">Provide one-stop solutions for brands in 3C industry, IT industry, home appliance and automobile industry。</div>
      </div>

      <div class="common-card pc">
        <div class="p2" style="line-height: 44px">
          <p>Provide after-sales service management </p>
          <p>for brand enterprises in the 3C industry, IT industry, home appliances and automobiles, etc。</p>
        </div>
        <div class="img-contain" style="margin-right: 0;margin-left: 20px">
          <img class="img4 strong-img" src="@/assets/first.jpeg" >
        </div>
      </div>
      <div class="common-card mobile">
        <div class="img-contain" style="margin-right: 0;margin-left: 20px">
          <img class="img4 strong-img" src="@/assets/first.jpeg" >
        </div>
        <div class="p2" style="line-height: 44px">
          <p>Provide after-sales service management </p>
          <p>for brand enterprises in the 3C industry, IT industry, home appliances and automobiles, etc。</p>
        </div>
      </div>

      <div class="common-card">
        <div class="img-contain">
          <img class="img4 strong-img" src="@/assets/s-imag-4.jpeg" >
        </div>
        <div class="p2" style="line-height: 44px">We provide professional after-sales spare parts management, overseas spare parts after-sales maintenance system, after-sales service management, local service provider management of regional/local warehousing, international logistics and transportation, import and export customs services and other services。</div>
      </div>
    </section>
  </div>

<!--  <div style="height: 50px"></div>-->
</div>
</template>

<script>
import Products from "@/views/products.vue";

export default {
  name: "solution",
  components: {Products},
  data() {
    return {
      activeIndex: 0,
      img: require('@/assets/solution2/导图1.jpeg'),
      img_en: require('@/assets/solution2/all1.jpeg'),
      img2_en: require('@/assets/solution2/all2.png'),
      contentClass: 'content',
    }
  },
  computed: {
    is_en() {
      return this.$t('language') === 'English'
    },
    list() {
      return [
        {
          title: this.$t('solution1.computer_industry.title'),
          title2: this.$t('solution1.computer_industry.title2'),
          desc1: this.$t('solution1.computer_industry.desc1'),
          desc2: this.$t('solution1.computer_industry.desc2'),
          img: require('@/assets/solution1/computer.png')
        },
        {
          title: this.$t('solution1.phone_industry.title'),
          title2: this.$t('solution1.phone_industry.title2'),
          desc1: this.$t('solution1.phone_industry.desc1'),
          desc2: this.$t('solution1.phone_industry.desc2'),
          img: require('@/assets/solution1/phone1.png')
        },
        {
          title: this.$t('solution1.car_industry.title'),
          title2: this.$t('solution1.car_industry.title2'),
          desc1: this.$t('solution1.car_industry.desc1'),
          desc2: this.$t('solution1.car_industry.desc2'),
          img: require('@/assets/solution1/car.png')
        },
        {
          title: this.$t('solution1.communication_industry.title'),
          title2: this.$t('solution1.communication_industry.title2'),
          desc1: this.$t('solution1.communication_industry.desc1'),
          desc2: this.$t('solution1.communication_industry.desc2'),
          img: require('@/assets/solution1/wifi.png')
        },
        {
          title: this.$t('solution1.home_appliance_industry.title'),
          title2: this.$t('solution1.home_appliance_industry.title2'),
          desc1: this.$t('solution1.home_appliance_industry.desc1'),
          desc2: this.$t('solution1.home_appliance_industry.desc2'),
          img: require('@/assets/solution1/jiadian.png')
        },
        {
          title: this.$t('solution1.digital_product_industry.title'),
          title2: this.$t('solution1.digital_product_industry.title2'),
          desc1: this.$t('solution1.digital_product_industry.desc1'),
          desc2: this.$t('solution1.digital_product_industry.desc2'),
          img: require('@/assets/solution1/camera.png')
        },
        {
          title: this.$t('solution1.medical_equipment_industry.title'),
          title2: this.$t('solution1.medical_equipment_industry.title2'),
          desc1: this.$t('solution1.medical_equipment_industry.desc1'),
          desc2: this.$t('solution1.medical_equipment_industry.desc2'),
          img: require('@/assets/solution1/hospital.png')
        }
      ];
    }
  },
  methods: {
    handleSelect(index, indexPath) {
      this.contentClass = 'content'
      setTimeout(() => {
        this.activeIndex = index
        this.contentClass = 'content slide-element'
      }, 200)
    }
  },
  mounted() {
    this.handleSelect(this.activeIndex)
  }
}
</script>

<style lang="scss">
section {
  width: 1200px;
  margin: 0 auto;
  padding-top: 5rem;
}
.common-card{
  display: flex;
  margin-bottom: 40px;
  .img-contain{
    margin-right: 40px;
  }
}

.solution {
  margin: 0 auto;
  position: relative;
  line-height: 2;
  min-height: calc(100vh - 60px - 60px);
  h2 {
    //color: var(--primary-color);
    color: #000000;
    margin-bottom: 3rem;
    font-size: 40px;
    font-family: Inter, Tahoma, Verdana, sans-serif;
    text-align: center;
    font-weight: 500;
  }
  .el-card {
    margin-bottom: 30px;
  }
  .group {
    display: flex;
    align-items: center;
  }
  .img {
    width: 800px;
    height: 350px;
    position: relative;
    overflow: hidden;
    margin: 0 auto;
  }
  .img1 {
    position: absolute;
    width: 800px;
    top: -120px;
    left: 50%;
    margin-left: -400px;
    z-index: 1;
  }
  .img4 {
    //position: absolute;
    //width: 600px;
    //top: -30px;
    //left: 50%;
    //margin-left: -300px;
    width: 600px;
    border-radius: 5px;
    z-index: 1;
  }
  .img2 {
    height: 300px;
    background: rgb(246,246,248);
    margin-right: 20px;
    border-radius: 10px;
    overflow: hidden;
  }
  .img3 {
    width: 600px;
    border-radius: 5px;
    overflow: hidden;
  }
  .p1,.p2,.p3 {
    padding-bottom: 30px;
  }
  .p2{
    font-size: 22px;
    line-height: 33px;
    max-width: 900px;
    margin: 0 auto 3rem;
    color: #000;
    font-family: Inter, Tahoma, Verdana, sans-serif;
  }
}
.mobile {
  display: none;
}
@media (max-width: 768px) {
  .solution-wrapper section{
    width: 100%;
    .mobile {
      display: block;
    }
    .common-card.pc {
      display: none;
    }
    .common-card {
      display: block;
      .img-contain {
        margin: 0;
      }
      .strong-img {
        display: block;
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
        margin: 0 auto;
      }
    }
    .p2 {
      padding: 10px 20px;
    }
  }
}
</style>
